module.exports = __webpack_public_path__ + "static/img/jp_dzzhyj.af04a8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fajs/jp_dzzhyj.png
// module id = MhW0
// module chunks = 1